export default __webpack_public_path__ + "static/media/search.e23a7c15.svg";